import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAYTp4w5a2Y27bEK29PimBuTBG0CI2ICjM",
  authDomain: "linkedin-clone-cdc58.firebaseapp.com",
  projectId: "linkedin-clone-cdc58",
  storageBucket: "linkedin-clone-cdc58.appspot.com",
  messagingSenderId: "900410730083",
  appId: "1:900410730083:web:5eec5316f45c372c5fba56"
};


//This special line of codde connects everything

const firebaseApp = firebase.initializeApp(firebaseConfig);

//gets the firestore database

const db = firebaseApp.firestore();
//We want to use firebase authentication
const auth = firebase.auth();
// firebase - Storage
const storage = firebase.storage();
export { db, auth, storage };
